import React from "react"
import styled from "styled-components"

import { League } from "../types"

const ThumbsUpIcon: string = require("../../../../assets/images/ui-icons/thumbs-up.svg").default
const PlayerIcon: string = require("../../../../assets/images/ui-icons/player.svg").default

interface ListViewProps {
  leagues: Array<League>
}

export default function ListView({ leagues }: ListViewProps) {
  return (
    <List>
      {leagues.map((l) => (
        <LeagueCard key={l.id} league={l} />
      ))}
    </List>
  )
}

function LeagueCard({ league }) {
  return (
    <Card>
      <Body>
        <Main>
          <h5>{league.nameWithoutCourse}</h5>
          <p>Started {league.startMonthAndDate}</p>
          <p>Ended {league.endMonthAndDate}</p>
        </Main>
      </Body>
      {league.ratingsCount && league.ratingsCount > 0 ? (
        <Stats>
          <Stat>
            <ThumbsUpIcon /> {league.positiveRatingPercent}% ({league.ratingsCount})
          </Stat>
          <Stat>
            <PlayerIcon /> {league.playerCount} players
          </Stat>
        </Stats>
      ) : (
        <></>
      )}
    </Card>
  )
}

const List = styled.ul`
  padding: 0;
  margin: 1rem 0 !important;
  list-style: none !important;
  line-height: 1rem !important;
`

const Card = styled.li`
  display: block;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: white;
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;

  p {
    font-size: 0.875rem;
    margin-bottom: 0 !important;
    line-height: 1.4rem;
  }
`

const Body = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 1rem;
`

const Main = styled.div`
  h5 {
    font-weight: bold;
    font-size: 1rem;
    line-height: 1.25rem;
    margin: 0 0 0.25rem;
    color: black;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

const Stats = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
`

const Stat = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 0.875rem;
  column-gap: 0.5rem;
  line-height: 1.4rem;

  svg {
    max-width: 1rem;
    max-height: 1rem;
  }
`
